import { render, staticRenderFns } from "./IconSap.vue?vue&type=template&id=f336ae76"
import script from "./IconSap.vue?vue&type=script&lang=js"
export * from "./IconSap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports